import { get, put, post, del } from '../api/_basic';

class ManageFormApi {
    static async getForm(processCode) {
        try {
            const response = await get(process.env.REACT_APP_API_MANAGE_FORM + '/' + processCode);
            return await ManageFormApi.processForm(response);
        } catch (error) {
            return { error: error };
        }
    }

    static async processForm(data) {
        try {
            console.log('processForm', data);
            if (!data) return undefined;
            const { codigo, proceso } = data[0];

            var p1 = new Promise((resolve, reject) => {
                resolve(
                    get(
                        process.env.REACT_APP_API_MANAGE_FORM +
                            '/' +
                            proceso +
                            '/' +
                            codigo +
                            '/campos',
                    ),
                );
                reject();
            });
            var p2 = new Promise((resolve, reject) => {
                resolve(get(process.env.REACT_APP_API_MANAGE_PROCESS + '/' + proceso + '/reglas'));
                reject();
            });
            var p3 = new Promise((resolve, reject) => {
                resolve(
                    get(
                        process.env.REACT_APP_API_MANAGE_PROCESS +
                            '/' +
                            proceso +
                            '/transicionesregla',
                    ),
                );
                reject();
            });

            return await Promise.all([p1, p2, p3]).then((values) => {
                return {
                    tabs: values[0],
                    form: codigo,
                    rules: values[1],
                    transitions: values[2],
                };
            });
        } catch (error) {
            console.log('error: ' + error);
            return { error: error };
        }
    }

    static async getRule(id) {
        try {
            return await get(process.env.REACT_APP_API_RULE + '/' + id);
        } catch (error) {
            return { error: error };
        }
    }

    static async postRule(rule) {
        try {
            return await post(process.env.REACT_APP_API_RULE, rule);
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    static async updateRule(rule) {
        try {
            return await put(process.env.REACT_APP_API_RULE + '/' + rule.id, rule);
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    static async deleteRule(rule) {
        try {
            return await del(process.env.REACT_APP_API_RULE + '/' + rule.id);
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    static flatTree(list) {
        if (list && list.length > 0) {
            return list.reduce((arr, node) => {
                const childs = node.hijos;
                arr.push(node);
                if (childs && childs.length > 0) {
                    arr = arr.concat(ManageFormApi.flatTree(childs));
                }
                return arr;
            }, []);
        } else {
            return [];
        }
    }

    static prepareFiles(fields, isParentNew) {
        let campoanterior = null;
        return fields.map((element) => {
            if (isParentNew) {
                //delete element.padre;
            }
            element.campoanterior = campoanterior;
            campoanterior = element.codigo;
            const isNew = element.nuevo;
            if (element.nuevo) {
                delete element.nuevo;
                //delete element.codigo;
            }
            if (element.hijos && element.hijos.length > 0) {
                element.hijos = ManageFormApi.prepareFiles(element.hijos, isNew);
            }
            return element;
        });
    }

    static async duplicate(processCode, form, element) {
        const tasks = [element].concat(ManageFormApi.flatTree(element.hijos));
        await tasks.reduce((promise, item) => {
            return promise.then(() => {
                return new Promise((resolve, reject) => {
                    post(
                        process.env.REACT_APP_API_MANAGE_FIELD + '/' + processCode + '/' + form,
                        item,
                    ).then((response) => {
                        return response;
                    });
                });
            });
        }, Promise.resolve());
    }

    static async postTab(processCode, form, tab) {
        try {
            await post(process.env.REACT_APP_API_MANAGE_TAB + '/' + processCode + '/' + form, tab);
            return true;
        } catch (error) {
            return { error: error };
        }
    }

    static async updateTab(processCode, form, tab) {
        try {
            await put(
                `${process.env.REACT_APP_API_MANAGE_TAB}/${processCode}/${form}/${tab.codigo}`,
                tab,
            );
            return true;
        } catch (error) {
            return { error: error };
        }
    }

    static async deleteTab(processCode, form, id) {
        try {
            await del(
                process.env.REACT_APP_API_MANAGE_TAB + '/' + processCode + '/' + form + '/' + id,
            );
            return true;
        } catch (error) {
            return { error: error };
        }
    }

    static async postSection(processCode, form, seccion) {
        try {
            await post(
                process.env.REACT_APP_API_MANAGE_SECTION + '/' + processCode + '/' + form,
                seccion,
            );
            return true;
        } catch (error) {
            return { error: error };
        }
    }

    static async updateSection(processCode, form, seccion) {
        try {
            await put(
                `${process.env.REACT_APP_API_MANAGE_SECTION}/${processCode}/${form}/${seccion.codigo}`,
                seccion,
            );
            return true;
        } catch (error) {
            return { error: error };
        }
    }

    static async deleteSection(processCode, form, id) {
        try {
            await del(`${process.env.REACT_APP_API_MANAGE_SECTION}/${processCode}/${form}/${id}`);
            return true;
        } catch (error) {
            return { error: error };
        }
    }

    static async postField(processCode, form, field) {
        try {
            await post(
                process.env.REACT_APP_API_MANAGE_FIELD + '/' + processCode + '/' + form,
                field,
            );
            return true;
        } catch (error) {
            return { error: error };
        }
    }

    static async updateField(processCode, form, field) {
        try {
            await put(
                `${process.env.REACT_APP_API_MANAGE_FIELD}/${processCode}/${form}/${field.codigo}`,
                field,
            );
            return true;
        } catch (error) {
            return { error: error };
        }
    }

    static async deleteField(processCode, form, id) {
        try {
            await del(
                process.env.REACT_APP_API_MANAGE_FIELD + '/' + processCode + '/' + form + '/' + id,
            );
            return true;
        } catch (error) {
            return { error: error };
        }
    }

    static async updateForm(processCode, form, fields) {
        try {
            fields = ManageFormApi.prepareFiles(fields);
            await put(
                process.env.REACT_APP_API_MANAGE_FORM + '/' + processCode + '/' + form + '/campos',
                { campos: fields },
            );
            return true;
        } catch (error) {
            return { error: error };
        }
    }
}

export default ManageFormApi;



// WEBPACK FOOTER //
// ./src/api/ManageFormApi.js